(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pbn-hero-paint"] && !Shopify.designMode) return;
  try {
    
function pbnProcess(src, w, h, opt) {
  var N = w * h, K = opt.k || 14, minArea = opt.minArea || 150;
  var x, y, p, i, j, c;

  /* 1. light 3x3 box blur (separable) */
  var R = new Float32Array(N), G = new Float32Array(N), B = new Float32Array(N);
  var tR = new Float32Array(N), tG = new Float32Array(N), tB = new Float32Array(N);
  for (y = 0; y < h; y++) {
    var row = y * w;
    for (x = 0; x < w; x++) {
      var xa = x > 0 ? x - 1 : x, xb = x < w - 1 ? x + 1 : x;
      var qa = (row + xa) * 4, qm = (row + x) * 4, qb = (row + xb) * 4;
      tR[row + x] = src[qa] + src[qm] + src[qb];
      tG[row + x] = src[qa + 1] + src[qm + 1] + src[qb + 1];
      tB[row + x] = src[qa + 2] + src[qm + 2] + src[qb + 2];
    }
  }
  for (y = 0; y < h; y++) {
    var ra = (y > 0 ? y - 1 : y) * w, rm = y * w, rb = (y < h - 1 ? y + 1 : y) * w;
    for (x = 0; x < w; x++) {
      R[rm + x] = (tR[ra + x] + tR[rm + x] + tR[rb + x]) / 9;
      G[rm + x] = (tG[ra + x] + tG[rm + x] + tG[rb + x]) / 9;
      B[rm + x] = (tB[ra + x] + tB[rm + x] + tB[rb + x]) / 9;
    }
  }
  tR = tG = tB = null;

  /* 2. k-means (k-means++ init) on a sample */
  var seed = 1234567;
  function rnd() { seed = (seed * 1664525 + 1013904223) >>> 0; return seed / 4294967296; }
  function dist(r1, g1, b1, r2, g2, b2) { var a = r1 - r2, b = g1 - g2, d = b1 - b2; return 2 * a * a + 4 * b * b + 3 * d * d; }
  var S = Math.min(N, 7000), sIdx = new Int32Array(S);
  for (i = 0; i < S; i++) sIdx[i] = Math.floor(rnd() * N);
  var cr = new Float32Array(K), cg = new Float32Array(K), cb = new Float32Array(K);
  var d2 = new Float32Array(S).fill(1e20);
  p = sIdx[0]; cr[0] = R[p]; cg[0] = G[p]; cb[0] = B[p];
  for (c = 1; c < K; c++) {
    var tot = 0;
    for (i = 0; i < S; i++) { p = sIdx[i]; var dd = dist(R[p], G[p], B[p], cr[c - 1], cg[c - 1], cb[c - 1]); if (dd < d2[i]) d2[i] = dd; tot += d2[i]; }
    var t = rnd() * tot, pick = S - 1;
    for (i = 0; i < S; i++) { t -= d2[i]; if (t <= 0) { pick = i; break; } }
    p = sIdx[pick]; cr[c] = R[p]; cg[c] = G[p]; cb[c] = B[p];
  }
  var asg = new Uint8Array(S), sumR = new Float64Array(K), sumG = new Float64Array(K), sumB = new Float64Array(K), cnt = new Int32Array(K);
  for (var it = 0; it < 14; it++) {
    sumR.fill(0); sumG.fill(0); sumB.fill(0); cnt.fill(0);
    for (i = 0; i < S; i++) {
      p = sIdx[i]; var best = 0, bd = 1e20;
      for (c = 0; c < K; c++) { var e = dist(R[p], G[p], B[p], cr[c], cg[c], cb[c]); if (e < bd) { bd = e; best = c; } }
      asg[i] = best; sumR[best] += R[p]; sumG[best] += G[p]; sumB[best] += B[p]; cnt[best]++;
    }
    for (c = 0; c < K; c++) {
      if (cnt[c]) { cr[c] = sumR[c] / cnt[c]; cg[c] = sumG[c] / cnt[c]; cb[c] = sumB[c] / cnt[c]; }
      else { p = sIdx[Math.floor(rnd() * S)]; cr[c] = R[p]; cg[c] = G[p]; cb[c] = B[p]; }
    }
  }

  /* 3. assign every pixel (via a 15-bit color lookup table) */
  var idx = new Uint8Array(N), lut = new Int8Array(32768).fill(-1);
  for (p = 0; p < N; p++) {
    var key = ((R[p] >> 3) << 10) | ((G[p] >> 3) << 5) | (B[p] >> 3);
    var hit = lut[key];
    if (hit < 0) {
      var qr = (R[p] >> 3) * 8 + 4, qg = (G[p] >> 3) * 8 + 4, qb = (B[p] >> 3) * 8 + 4, b2 = 0, bd2 = 1e20;
      for (c = 0; c < K; c++) { var e2 = dist(qr, qg, qb, cr[c], cg[c], cb[c]); if (e2 < bd2) { bd2 = e2; b2 = c; } }
      lut[key] = hit = b2;
    }
    idx[p] = hit;
  }

  /* 4. mode filter (smooths jagged borders, interior pixels are skipped) */
  var counts = new Int32Array(K), tmp = new Uint8Array(N);
  for (var pass = 0; pass < 3; pass++) {
    tmp.set(idx);
    for (y = 1; y < h - 1; y++) {
      for (x = 1; x < w - 1; x++) {
        p = y * w + x; var cc = idx[p];
        if (idx[p - 1] === cc && idx[p + 1] === cc && idx[p - w] === cc && idx[p + w] === cc &&
            idx[p - w - 1] === cc && idx[p - w + 1] === cc && idx[p + w - 1] === cc && idx[p + w + 1] === cc) continue;
        counts.fill(0);
        counts[idx[p - w - 1]]++; counts[idx[p - w]]++; counts[idx[p - w + 1]]++;
        counts[idx[p - 1]]++; counts[cc]++; counts[idx[p + 1]]++;
        counts[idx[p + w - 1]]++; counts[idx[p + w]]++; counts[idx[p + w + 1]]++;
        var bc = cc, bn = counts[cc];
        for (c = 0; c < K; c++) if (counts[c] > bn) { bn = counts[c]; bc = c; }
        tmp[p] = bc;
      }
    }
    idx.set(tmp);
  }

  /* 5. connected components + merge tiny regions */
  var labels = new Int32Array(N), stack = new Int32Array(N);
  function components() {
    labels.fill(-1); var nl = 0, sizes = [];
    for (var s = 0; s < N; s++) {
      if (labels[s] >= 0) continue;
      var col = idx[s], top = 0, size = 0; stack[top++] = s; labels[s] = nl;
      while (top) {
        var v = stack[--top]; size++;
        var vx = v % w;
        if (vx > 0 && labels[v - 1] < 0 && idx[v - 1] === col) { labels[v - 1] = nl; stack[top++] = v - 1; }
        if (vx < w - 1 && labels[v + 1] < 0 && idx[v + 1] === col) { labels[v + 1] = nl; stack[top++] = v + 1; }
        if (v >= w && labels[v - w] < 0 && idx[v - w] === col) { labels[v - w] = nl; stack[top++] = v - w; }
        if (v < N - w && labels[v + w] < 0 && idx[v + w] === col) { labels[v + w] = nl; stack[top++] = v + w; }
      }
      sizes.push(size); nl++;
    }
    return sizes;
  }
  var sizes;
  for (var mi = 0; mi < 4; mi++) {
    sizes = components();
    var nl = sizes.length, small = 0;
    for (i = 0; i < nl; i++) if (sizes[i] < minArea) small++;
    if (!small) break;
    var nc = new Int32Array(nl * K);
    for (p = 0; p < N; p++) {
      var L = labels[p]; if (sizes[L] >= minArea) continue;
      var px = p % w;
      if (px > 0 && labels[p - 1] !== L) nc[L * K + idx[p - 1]]++;
      if (px < w - 1 && labels[p + 1] !== L) nc[L * K + idx[p + 1]]++;
      if (p >= w && labels[p - w] !== L) nc[L * K + idx[p - w]]++;
      if (p < N - w && labels[p + w] !== L) nc[L * K + idx[p + w]]++;
    }
    var target = new Int16Array(nl).fill(-1);
    for (i = 0; i < nl; i++) {
      if (sizes[i] >= minArea) continue;
      var bk = -1, bv = 0;
      for (c = 0; c < K; c++) if (nc[i * K + c] > bv) { bv = nc[i * K + c]; bk = c; }
      target[i] = bk;
    }
    for (p = 0; p < N; p++) { var tg = target[labels[p]]; if (tg >= 0) idx[p] = tg; }
  }
  sizes = components();
  var nR = sizes.length;

  /* 6. region data + pixel lists */
  var starts = new Int32Array(nR + 1);
  for (i = 0; i < nR; i++) starts[i + 1] = starts[i] + sizes[i];
  var fillPos = starts.slice(0, nR), list = new Int32Array(N);
  var rColor = new Uint8Array(nR), rArea = new Int32Array(nR), rCx = new Float32Array(nR), rCy = new Float32Array(nR);
  var rBox = new Int32Array(nR * 4);
  for (i = 0; i < nR; i++) { rBox[i * 4] = w; rBox[i * 4 + 1] = h; rBox[i * 4 + 2] = -1; rBox[i * 4 + 3] = -1; }
  for (p = 0; p < N; p++) {
    var l = labels[p]; list[fillPos[l]++] = p; x = p % w; y = (p / w) | 0;
    rColor[l] = idx[p]; rArea[l]++; rCx[l] += x; rCy[l] += y;
    var o = l * 4;
    if (x < rBox[o]) rBox[o] = x; if (y < rBox[o + 1]) rBox[o + 1] = y;
    if (x > rBox[o + 2]) rBox[o + 2] = x; if (y > rBox[o + 3]) rBox[o + 3] = y;
  }
  for (i = 0; i < nR; i++) { rCx[i] /= rArea[i]; rCy[i] /= rArea[i]; }

  /* 7. edges + distance transform for number placement */
  var edge = new Uint8Array(N), dt = new Float32Array(N);
  for (y = 0; y < h; y++) {
    for (x = 0; x < w; x++) {
      p = y * w + x; var lb = labels[p];
      var isE = (x < w - 1 && labels[p + 1] !== lb) || (y < h - 1 && labels[p + w] !== lb);
      if (isE) edge[p] = 1;
      var bnd = x === 0 || y === 0 || x === w - 1 || y === h - 1 || isE ||
        (x > 0 && labels[p - 1] !== lb) || (y > 0 && labels[p - w] !== lb);
      dt[p] = bnd ? 0 : 1e9;
    }
  }
  var D = 1.4142;
  for (y = 1; y < h; y++) for (x = 1; x < w - 1; x++) {
    p = y * w + x; var v0 = dt[p];
    if (dt[p - 1] + 1 < v0) v0 = dt[p - 1] + 1;
    if (dt[p - w] + 1 < v0) v0 = dt[p - w] + 1;
    if (dt[p - w - 1] + D < v0) v0 = dt[p - w - 1] + D;
    if (dt[p - w + 1] + D < v0) v0 = dt[p - w + 1] + D;
    dt[p] = v0;
  }
  for (y = h - 2; y >= 0; y--) for (x = w - 2; x >= 1; x--) {
    p = y * w + x; var v1 = dt[p];
    if (dt[p + 1] + 1 < v1) v1 = dt[p + 1] + 1;
    if (dt[p + w] + 1 < v1) v1 = dt[p + w] + 1;
    if (dt[p + w + 1] + D < v1) v1 = dt[p + w + 1] + D;
    if (dt[p + w - 1] + D < v1) v1 = dt[p + w - 1] + D;
    dt[p] = v1;
  }
  var rNx = new Float32Array(nR), rNy = new Float32Array(nR), rNd = new Float32Array(nR);
  for (p = 0; p < N; p++) { var lr = labels[p]; if (dt[p] > rNd[lr]) { rNd[lr] = dt[p]; rNx[lr] = p % w; rNy[lr] = (p / w) | 0; } }

  /* 8. palette, numbered light -> dark */
  var used = new Uint8Array(K);
  for (i = 0; i < nR; i++) used[rColor[i]] = 1;
  var order = [];
  for (c = 0; c < K; c++) if (used[c]) order.push(c);
  order.sort(function (a, b) {
    return (0.299 * cr[b] + 0.587 * cg[b] + 0.114 * cb[b]) - (0.299 * cr[a] + 0.587 * cg[a] + 0.114 * cb[a]);
  });
  var remap = new Uint8Array(K), palette = new Uint8Array(order.length * 3);
  for (i = 0; i < order.length; i++) {
    remap[order[i]] = i;
    palette[i * 3] = Math.round(cr[order[i]]); palette[i * 3 + 1] = Math.round(cg[order[i]]); palette[i * 3 + 2] = Math.round(cb[order[i]]);
  }
  for (i = 0; i < nR; i++) rColor[i] = remap[rColor[i]];

  return {
    w: w, h: h, nR: nR, palette: palette, starts: starts, list: list, edge: edge,
    rColor: rColor, rArea: rArea, rCx: rCx, rCy: rCy, rBox: rBox, rNx: rNx, rNy: rNy, rNd: rNd
  };
}
if (!customElements.get('pbn-hero-paint')) {
  var PBN_PROCESS = pbnProcess;

  class PbnHeroPaint extends HTMLElement {
    connectedCallback() {
      this.media = this.querySelector('.pbn-hp__media');
      this.base = this.querySelector('.pbn-hp__img--base');
      this.canvas = this.querySelector('.pbn-hp__canvas');
      this.photo = this.querySelector('.pbn-hp__photo');
      this.brush = this.querySelector('.pbn-hp__brush');
      this.swatchWrap = this.querySelector('.pbn-hp__swatches');
      this.replayBtn = this.querySelector('.pbn-hp__replay');
      if (!this.base || !this.canvas) return;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.classList.add('is-js');
      this.onReplay = () => this.replay();
      if (this.replayBtn) this.replayBtn.addEventListener('click', this.onReplay);
      /* never compete with page load: wait for window load, idle time and visibility */
      const idle = (fn) => ('requestIdleCallback' in window ? requestIdleCallback(fn, { timeout: 1500 }) : setTimeout(fn, 250));
      const whenVisible = (fn) => {
        if (!('IntersectionObserver' in window)) return fn();
        this.io = new IntersectionObserver((entries) => {
          if (entries.some((e) => e.isIntersecting)) { this.io.disconnect(); fn(); }
        }, { rootMargin: '100px' });
        this.io.observe(this);
      };
      const go = () => {
        if (this.started) return;
        this.started = true;
        if (!this.base.complete || !this.base.naturalWidth) {
          this.base.addEventListener('load', () => this.build(true), { once: true });
          this.base.addEventListener('error', () => this.fail(), { once: true });
        } else this.build(true);
      };
      const afterLoad = () => idle(() => whenVisible(go));
      if (document.readyState === 'complete') afterLoad();
      else window.addEventListener('load', afterLoad, { once: true });
      this.lastW = 0;
      this.ro = new ResizeObserver(() => {
        clearTimeout(this.rt);
        this.rt = setTimeout(() => {
          if (!this.state) return;
          const r = this.media.getBoundingClientRect();
          if (Math.abs(r.width - this.lastW) / (this.lastW || 1) > 0.08 || Math.abs(r.height / r.width - this.lastAR) > 0.06) this.build(false);
        }, 300);
      });
      this.ro.observe(this.media);
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.raf);
      clearTimeout(this.failTimer);
      if (this.worker) this.worker.terminate();
      if (this.ro) this.ro.disconnect();
      if (this.io) this.io.disconnect();
      if (this.maskUrl) URL.revokeObjectURL(this.maskUrl);
    }

    fail() {
      cancelAnimationFrame(this.raf);
      this.classList.remove('is-js', 'is-ready', 'is-revealed');
      this.classList.add('is-fallback');
    }

    async build(animate) {
      const rect = this.media.getBoundingClientRect();
      const cw = Math.round(rect.width), ch = Math.round(rect.height);
      if (!cw || !ch) return;
      this.lastW = cw; this.lastAR = ch / cw;
      const mobile = cw < 750;
      const lowEnd = (navigator.hardwareConcurrency || 8) <= 4 || (navigator.deviceMemory || 8) <= 3;
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      const factor = mobile ? (lowEnd ? 1.5 : Math.max(1, dpr)) : (lowEnd ? 0.85 : 1);
      let pw = Math.max(300, Math.min(mobile ? 860 : 1600, Math.round(cw * factor)));
      clearTimeout(this.failTimer);
      this.failTimer = setTimeout(() => this.fail(), 9000);
      let ph = Math.round(pw * ch / cw);
      const maxPx = mobile ? (lowEnd ? 420000 : 650000) : 1500000;
      if (pw * ph > maxPx) { const f = Math.sqrt(maxPx / (pw * ph)); pw = Math.round(pw * f); ph = Math.round(ph * f); }
      let data;
      try {
        const im = new Image();
        im.crossOrigin = 'anonymous';
        im.src = this.base.currentSrc || this.base.src;
        await im.decode();
        const sAR = im.naturalWidth / im.naturalHeight, dAR = cw / ch;
        let sx = 0, sy = 0, sw = im.naturalWidth, sh = im.naturalHeight;
        if (sAR > dAR) { sw = sh * dAR; sx = (im.naturalWidth - sw) / 2; } else { sh = sw / dAR; sy = (im.naturalHeight - sh) / 2; }
        const off = document.createElement('canvas');
        off.width = pw; off.height = ph;
        const octx = off.getContext('2d', { willReadFrequently: true });
        octx.drawImage(im, sx, sy, sw, sh, 0, 0, pw, ph);
        data = octx.getImageData(0, 0, pw, ph).data;
        this.photoUrl = im.src;
      } catch (e) { this.fail(); return; }
      const k = parseInt(this.dataset.colors, 10) || 14;
      const opt = { k: k, minArea: Math.round(pw * ph / (mobile ? 1100 : 1600)) };
      let res;
      try { res = await this.process(data, pw, ph, opt); } catch (e) { this.fail(); return; }
      clearTimeout(this.failTimer);
      await this.setup(res, cw, ch);
      if (animate && !this.reduced) this.play(); else this.finish(true);
    }

    process(data, w, h, opt) {
      return new Promise((resolve, reject) => {
        try {
          if (!this.workerUrl) {
            const code = 'var pbnProcess=' + PBN_PROCESS.toString() + ';self.onmessage=function(e){var d=e.data;var r=pbnProcess(d.data,d.w,d.h,d.opt);' +
              'self.postMessage(r,[r.list.buffer,r.edge.buffer,r.starts.buffer]);};';
            PbnHeroPaint.url = PbnHeroPaint.url || URL.createObjectURL(new Blob([code], { type: 'text/javascript' }));
            this.workerUrl = PbnHeroPaint.url;
          }
          if (this.worker) this.worker.terminate();
          this.worker = new Worker(this.workerUrl);
          this.worker.onmessage = (e) => { resolve(e.data); this.worker.terminate(); this.worker = null; };
          this.worker.onerror = (err) => { this.worker = null; reject(err); };
          this.worker.postMessage({ data: data, w: w, h: h, opt: opt });
        } catch (e) {
          reject(e); /* no worker: keep the plain photo rather than block the main thread */
        }
      });
    }

    async setup(R, cw, ch) {
      cancelAnimationFrame(this.raf);
      const w = R.w, h = R.h, nR = R.nR;
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      this.canvas.width = Math.round(cw * dpr);
      this.canvas.height = Math.round(ch * dpr);
      this.ctx = this.canvas.getContext('2d');
      this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      this.ctx.imageSmoothingEnabled = true;
      this.ctx.imageSmoothingQuality = 'high';
      this.pc = document.createElement('canvas');
      this.pc.width = w; this.pc.height = h;
      this.pctx = this.pc.getContext('2d');
      this.img = this.pctx.createImageData(w, h);
      this.cw = cw; this.ch = ch; this.R = R;
      const sx = cw / w, sy = ch / h;

      /* paint order: wave from bottom-left, stop before the top-right corner */
      const leave = Math.max(0, Math.min(0.6, (parseInt(this.dataset.leave, 10) || 0) / 100));
      const ids = [];
      const rnd = (i) => { const s = Math.sin(i * 12.9898) * 43758.5453; return s - Math.floor(s); };
      const score = new Float32Array(nR);
      for (let i = 0; i < nR; i++) {
        ids.push(i);
        score[i] = (R.rCx[i] / w) * 0.62 + (1 - R.rCy[i] / h) * 0.38 + rnd(i) * 0.07;
      }
      ids.sort((a, b) => score[a] - score[b]);
      let total = 0; for (let i = 0; i < nR; i++) total += R.rArea[i];
      const paintTarget = total * (1 - leave);
      const dur = (parseFloat(this.dataset.duration) || 4.5) * 1000;
      this.start = new Float32Array(nR).fill(-1);
      this.painted = [];
      let acc = 0;
      for (let n = 0; n < ids.length; n++) {
        const i = ids[n];
        if (acc >= paintTarget) break;
        acc += R.rArea[i];
        this.painted.push(i);
      }
      const P = this.painted.length;
      let cum = 0;
      for (let n = 0; n < P; n++) {
        const i = this.painted[n];
        const f = 0.55 * (n / Math.max(1, P - 1)) + 0.45 * (cum / Math.max(1, acc));
        cum += R.rArea[i];
        this.start[i] = f * dur;
      }
      this.duration = dur;

      /* numbers, placed in the widest point of each region */
      const cand = [];
      for (let i = 0; i < nR; i++) {
        const fs = Math.min(15, R.rNd[i] * Math.min(sx, sy) * 0.95);
        if (fs >= 8) cand.push({ i: i, x: (R.rNx[i] + 0.5) * sx, y: (R.rNy[i] + 0.5) * sy, fs: fs, d: R.rNd[i] });
      }
      cand.sort((a, b) => b.d - a.d);
      this.nums = [];
      for (const c of cand) {
        let ok = true;
        for (const n of this.nums) { const dx = n.x - c.x, dy = n.y - c.y; if (dx * dx + dy * dy < 400) { ok = false; break; } }
        if (ok) this.nums.push(c);
        if (this.nums.length > 320) break;
      }

      /* palette swatches */
      const pal = R.palette, K = pal.length / 3;
      this.cols = [];
      for (let c = 0; c < K; c++) this.cols.push([pal[c * 3], pal[c * 3 + 1], pal[c * 3 + 2]]);
      if (this.swatchWrap) {
        this.swatchWrap.innerHTML = '';
        this.swatchEls = this.cols.map((col, c) => {
          const s = document.createElement('span');
          const lum = 0.299 * col[0] + 0.587 * col[1] + 0.114 * col[2];
          s.className = 'pbn-hp__sw';
          s.style.background = 'rgb(' + col.join(',') + ')';
          s.style.color = lum > 150 ? '#2b2940' : '#ffffff';
          s.textContent = c + 1;
          this.swatchWrap.appendChild(s);
          return s;
        });
      }

      /* mask for the real photo (only painted regions) */
      const mc = document.createElement('canvas');
      mc.width = w; mc.height = h;
      const mctx = mc.getContext('2d');
      const md = mctx.createImageData(w, h);
      for (const i of this.painted) {
        for (let k = R.starts[i]; k < R.starts[i + 1]; k++) md.data[R.list[k] * 4 + 3] = 255;
      }
      mctx.putImageData(md, 0, 0);
      try {
        const blob = await new Promise((r) => mc.toBlob(r, 'image/png'));
        if (blob) {
          if (this.maskUrl) URL.revokeObjectURL(this.maskUrl);
          this.maskUrl = URL.createObjectURL(blob);
          const url = 'url("' + this.maskUrl + '")';
          this.photo.style.webkitMaskImage = url;
          this.photo.style.maskImage = url;
          this.photo.style.backgroundImage = 'url("' + this.photoUrl + '")';
        }
      } catch (e) {}

      this.state = true;
      this.resetPixels();
      this.prog = new Float32Array(nR);
    }

    resetPixels() {
      const R = this.R, d = this.img.data, N = R.w * R.h;
      for (let p = 0; p < N; p++) {
        const o = p * 4;
        if (R.edge[p]) { d[o] = 150; d[o + 1] = 147; d[o + 2] = 156; }
        else { d[o] = 251; d[o + 1] = 249; d[o + 2] = 244; }
        d[o + 3] = 255;
      }
      this.pctx.putImageData(this.img, 0, 0);
    }

    paintRegion(i, a) {
      const R = this.R, d = this.img.data, col = this.cols[R.rColor[i]];
      const ia = 1 - a;
      const r = col[0], g = col[1], b = col[2];
      for (let k = R.starts[i]; k < R.starts[i + 1]; k++) {
        const p = R.list[k], o = p * 4;
        if (R.edge[p]) {
          d[o] = 150 * ia + r * 0.78 * a; d[o + 1] = 147 * ia + g * 0.78 * a; d[o + 2] = 156 * ia + b * 0.78 * a;
        } else {
          d[o] = 251 * ia + r * a; d[o + 1] = 249 * ia + g * a; d[o + 2] = 244 * ia + b * a;
        }
      }
    }

    draw() {
      const ctx = this.ctx;
      ctx.clearRect(0, 0, this.cw, this.ch);
      ctx.drawImage(this.pc, 0, 0, this.cw, this.ch);
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      for (const n of this.nums) {
        const a = 1 - this.prog[n.i];
        if (a <= 0.02) continue;
        ctx.globalAlpha = a;
        ctx.fillStyle = '#7d7a88';
        ctx.font = '600 ' + n.fs.toFixed(1) + 'px system-ui, -apple-system, "Segoe UI", sans-serif';
        ctx.fillText(String(this.R.rColor[n.i] + 1), n.x, n.y);
      }
      ctx.globalAlpha = 1;
    }

    play() {
      this.classList.remove('is-revealed', 'is-done');
      this.classList.add('is-ready', 'is-painting');
      this.prog.fill(0);
      this.resetPixels();
      this.draw();
      const intro = 900, fade = 260;
      const t0 = performance.now() + intro;
      let lastBrush = 0, latest = -1;
      const order = this.painted;
      const step = (now) => {
        const t = now - t0;
        let x0 = 1e9, y0 = 1e9, x1 = -1, y1 = -1, any = false, done = true;
        for (let n = 0; n < order.length; n++) {
          const i = order[n], s = this.start[i];
          if (t < s) { done = false; continue; }
          if (this.prog[i] >= 1) continue;
          const a = Math.min(1, (t - s) / fade);
          if (a < 1) done = false;
          this.prog[i] = a;
          this.paintRegion(i, a);
          const o = i * 4, B = this.R.rBox;
          if (B[o] < x0) x0 = B[o]; if (B[o + 1] < y0) y0 = B[o + 1];
          if (B[o + 2] > x1) x1 = B[o + 2]; if (B[o + 3] > y1) y1 = B[o + 3];
          any = true;
          if (n > latest) latest = n;
        }
        if (any) this.pctx.putImageData(this.img, 0, 0, x0, y0, x1 - x0 + 1, y1 - y0 + 1);
        if (any) this.draw();
        if (latest >= 0 && now - lastBrush > 110) {
          lastBrush = now;
          const i = order[latest];
          this.moveBrush(i);
        }
        if (done && t > this.duration) { this.finish(false); return; }
        this.raf = requestAnimationFrame(step);
      };
      this.raf = requestAnimationFrame(step);
    }

    moveBrush(i) {
      const R = this.R, c = R.rColor[i];
      const x = R.rCx[i] * this.cw / R.w, y = R.rCy[i] * this.ch / R.h;
      if (this.brush) {
        this.brush.style.setProperty('--pbn-brush-color', 'rgb(' + this.cols[c].join(',') + ')');
        this.brush.style.transform = 'translate(' + (x - 8).toFixed(1) + 'px,' + (y - 40).toFixed(1) + 'px)';
      }
      if (this.swatchEls) {
        if (this.activeSw !== undefined && this.swatchEls[this.activeSw]) this.swatchEls[this.activeSw].classList.remove('is-active');
        this.activeSw = c;
        this.swatchEls[c].classList.add('is-active');
      }
    }

    finish(instant) {
      cancelAnimationFrame(this.raf);
      for (const i of this.painted) { this.prog[i] = 1; this.paintRegion(i, 1); }
      this.pctx.putImageData(this.img, 0, 0);
      this.draw();
      if (this.swatchEls && this.activeSw !== undefined && this.swatchEls[this.activeSw]) this.swatchEls[this.activeSw].classList.remove('is-active');
      this.classList.add('is-ready', 'is-done');
      this.classList.remove('is-painting');
      if (this.dataset.reveal === 'true') {
        if (instant) this.classList.add('is-revealed');
        else setTimeout(() => this.classList.add('is-revealed'), 500);
      }
    }

    replay() {
      if (!this.state || this.reduced) return;
      this.classList.remove('is-revealed');
      setTimeout(() => this.play(), 350);
    }
  }
  customElements.define('pbn-hero-paint', PbnHeroPaint);
}

  } catch(e) { console.error(e); }
})();
})();
